import type { Experience } from '../experience'

export type UnifiedBundleRefs = {
  entry: string
  css: string[]
}

export type UnifiedManifest = {
  legacy: UnifiedBundleRefs
  new: UnifiedBundleRefs
}

function isBundleRefs(v: unknown): v is UnifiedBundleRefs {
  if (!v || typeof v !== 'object') return false
  const o = v as UnifiedBundleRefs
  return typeof o.entry === 'string' && Array.isArray(o.css) && o.css.every((c) => typeof c === 'string')
}

export function isUnifiedManifest(v: unknown): v is UnifiedManifest {
  if (!v || typeof v !== 'object') return false
  const o = v as UnifiedManifest
  return isBundleRefs(o.legacy) && isBundleRefs(o.new)
}

export async function fetchUnifiedManifest(): Promise<UnifiedManifest> {
  const res = await fetch('/unified-manifest.json')
  if (!res.ok) {
    throw new Error(`unified-manifest.json ${res.status}`)
  }
  const data: unknown = await res.json()
  if (!isUnifiedManifest(data)) {
    throw new Error('Invalid unified-manifest.json')
  }
  return data
}

export function bundleForExperience(
  manifest: UnifiedManifest,
  experience: Experience,
): UnifiedBundleRefs {
  return experience === 'legacy' ? manifest.legacy : manifest.new
}
